import { IAgePriceMatrix, IBaseEdition, IEditionPricing } from 'src/interfaces/Edition';

function emptyAgePriceMatrix(): IAgePriceMatrix {
  return {
    childPrice: 0,
    youngPrice: 0,
    discountedPrice: 0,
    fullPrice: 0,
  };
}

function matrixFromFlat(edition: Partial<IAgePriceMatrix>): IAgePriceMatrix {
  return {
    childPrice: Number(edition.childPrice ?? 0),
    youngPrice: Number(edition.youngPrice ?? 0),
    discountedPrice: Number(edition.discountedPrice ?? 0),
    fullPrice: Number(edition.fullPrice ?? 0),
  };
}

/** Prefill form pricing: use embedded matrices when present, else copy flat into all periods. */
export function defaultPricingForForm(edition?: Partial<IBaseEdition> | null): IEditionPricing {
  if (edition?.pricing?.regular) {
    return {
      earlyBird: { ...matrixFromFlat(edition.pricing.earlyBird ?? edition.pricing.regular) },
      regular: { ...matrixFromFlat(edition.pricing.regular) },
      atLocation: { ...matrixFromFlat(edition.pricing.atLocation ?? edition.pricing.regular) },
    };
  }
  if (edition && edition.fullPrice != null) {
    const flat = matrixFromFlat(edition);
    return {
      earlyBird: { ...flat },
      regular: { ...flat },
      atLocation: { ...flat },
    };
  }
  return {
    earlyBird: emptyAgePriceMatrix(),
    regular: emptyAgePriceMatrix(),
    atLocation: emptyAgePriceMatrix(),
  };
}

/** Mirror regular matrix onto flat fields for API dual-write. */
export function flattenRegularPricing(form: IBaseEdition): IBaseEdition {
  const regular = form.pricing?.regular ?? matrixFromFlat(form);
  const groupPrice =
    typeof form.groupPrice === 'number' && !Number.isNaN(form.groupPrice)
      ? form.groupPrice
      : undefined;
  const childMaxAge =
    typeof form.childMaxAge === 'number' && !Number.isNaN(form.childMaxAge)
      ? form.childMaxAge
      : 6;
  return {
    ...form,
    childPrice: Number(regular.childPrice),
    youngPrice: Number(regular.youngPrice),
    discountedPrice: Number(regular.discountedPrice),
    fullPrice: Number(regular.fullPrice),
    childMaxAge,
    groupPrice,
    pricing: {
      earlyBird: matrixFromFlat(form.pricing?.earlyBird ?? regular),
      regular: matrixFromFlat(regular),
      atLocation: matrixFromFlat(form.pricing?.atLocation ?? regular),
    },
  };
}
